export interface AdsAccountApiRecord {
  id: string;
  platform: "meta" | "google" | "tiktok";
  externalAccountId: string;
  accountName: string;
  currency: string;
  status: "connected" | "disconnected" | "error" | "rate_limited";
  lastSyncAt: string | null;
  lastSyncError: string | null;
  createdAt: string;
}

export interface AdsConnectionFormInput {
  platform: "meta" | "google" | "tiktok";
  accountName: string;
  externalAccountId: string;
  accessToken: string;
  refreshToken: string;
  currency: string;
  timezone: string;
}

export interface NormalizedAdsAccount {
  id: string;
  platform: AdsAccountApiRecord["platform"];
  accountName: string;
  accountId: string;
  status: "active" | "paused" | "error";
  connectedAt: string;
  lastSyncAt: string | null;
  currency: string;
  lastSyncError: string | null;
}

export function normalizeAdsAccount(record: AdsAccountApiRecord): NormalizedAdsAccount {
  return {
    id: record.id,
    platform: record.platform,
    accountName: record.accountName,
    accountId: record.externalAccountId,
    status:
      record.status === "connected"
        ? "active"
        : record.status === "error"
          ? "error"
          : record.status === "rate_limited"
            ? "error"
            : "paused",
    connectedAt: record.createdAt,
    lastSyncAt: record.lastSyncAt,
    currency: record.currency,
    lastSyncError: record.lastSyncError,
  };
}

export function buildAdsAccountConnectPayload(form: AdsConnectionFormInput) {
  const payload = {
    platform: form.platform,
    accountName: form.accountName.trim(),
    externalAccountId: form.externalAccountId.trim(),
    accessToken: form.accessToken.trim(),
    refreshToken: form.refreshToken.trim(),
    currency: form.currency.trim().toUpperCase(),
    timezone: form.timezone.trim(),
  };

  return {
    platform: payload.platform,
    accountName: payload.accountName,
    externalAccountId: payload.externalAccountId,
    accessToken: payload.accessToken,
    ...(payload.refreshToken ? { refreshToken: payload.refreshToken } : {}),
    ...(payload.currency ? { currency: payload.currency } : {}),
    ...(payload.timezone ? { timezone: payload.timezone } : {}),
  };
}
